import { render, staticRenderFns } from "./AddFlourWeightModal.vue?vue&type=template&id=5d0a042e&"
import script from "./AddFlourWeightModal.vue?vue&type=script&lang=js&"
export * from "./AddFlourWeightModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports